/**
 * 쿼리 키 중앙 관리
 * React Query의 queryKey를 상수로 관리하여 일관성 유지
 */

// Auth
export const QK_AUTH_ORGANIZATION_LIST = 'QK_AUTH_ORGANIZATION_LIST';
export const QK_AUTH_DEPARTMENT_LIST = 'QK_AUTH_DEPARTMENT_LIST';
export const QK_AUTH_MEMBER_LIST = 'QK_AUTH_MEMBER_LIST';
export const QK_AUTH_CURRENT_USER = 'QK_AUTH_CURRENT_USER';
export const QK_AUTH_EMPLOYEE_DETAIL = 'QK_AUTH_EMPLOYEE_DETAIL';

// Survey
export const QK_PATIENT_AGREEMENTS = 'QK_PATIENT_AGREEMENTS';
export const QK_PATIENT_AGREEMENT_URL = 'QK_PATIENT_AGREEMENT_URL';
export const QK_SURVEY_APPOINTMENT_LIST = 'QK_SURVEY_APPOINTMENT_LIST';
export const QK_SURVEY_LAST_SESSION = 'QK_SURVEY_LAST_SESSION';
export const QK_PREFERENCE_ORG_DEFAULT = 'QK_PREFERENCE_ORG_DEFAULT';
export const QK_PREFERENCE_ORG = 'QK_PREFERENCE_ORG';
export const QK_PAYMENT_CARD_INFO = 'QK_PAYMENT_CARD_INFO';
export const QK_PAYMENT_INVOICE = 'QK_PAYMENT_INVOICE';
export const QK_PAYHUB_INVOICE_FILTER = 'QK_PAYHUB_INVOICE_FILTER';
export const QK_PAYHUB_METERED_FEE_RECORDS = 'QK_PAYHUB_METERED_FEE_RECORDS';
export const QK_PAYHUB_PACKAGE_FEE_RECORDS = 'QK_PAYHUB_PACKAGE_FEE_RECORDS';
export const QK_PAYHUB_CONTRACT_FEE_RECORDS = 'QK_PAYHUB_CONTRACT_FEE_RECORDS';
export const QK_PAYMENT_LAST_STATUS = 'QK_PAYMENT_LAST_STATUS';
export const QK_PATIENT_DETAIL = 'QK_PATIENT_DETAIL';
export const QK_PATIENT_LIST = 'QK_PATIENT_LIST';
export const QK_SURVEY_SESSION_LIST = 'QK_SURVEY_SESSION_LIST';
export const QK_PAYMENT_SESSION_RECORD = 'QK_PAYMENT_SESSION_RECORD';
export const QK_SURVEY_SESSION_URL = 'QK_SURVEY_SESSION_URL';
export const QK_SLEEP_DIARY_LIST = 'QK_SLEEP_DIARY_LIST';
export const QK_SLEEP_SESSION_LIST = 'QK_SLEEP_SESSION_LIST';
export const QK_PAYMENT_SURVEY_RECORD = 'QK_PAYMENT_SURVEY_RECORD';
export const QK_PAYMENT_INSURANCE_FEE_INFO = 'QK_PAYMENT_INSURANCE_FEE_INFO';
// Questionnaire
export const QK_QUESTIONNAIRE_LIST = 'QK_QUESTIONNAIRE_LIST';
export const QK_QUESTIONNAIRE_SLEEP_LIST = 'QK_QUESTIONNAIRE_SLEEP_LIST';

// Scan
export const QK_REC_HISTORY = 'QK_REC_HISTORY';
export const QK_SIGNAL_FILE = 'QK_SIGNAL_FILE';
export const QK_MODULE_LIST = 'QK_MODULE_LIST';
export const QK_SCAN_CONFIG = 'QK_SCAN_CONFIG';

// Stim
export const QK_STIM_SUBJECTS_LIST = 'QK_STIM_SUBJECTS_LIST';
export const QK_STIM_PRESCRIPTION_LIST = 'QK_STIM_PRESCRIPTION_LIST';
export const QK_STIM_SESSION_LIST = 'QK_STIM_SESSION_LIST';
export const QK_STIM_COMMISSION_STATUS = 'QK_STIM_COMMISSION_STATUS';

// Mobile
export const QK_MOBILE_ORG_PREFERENCE = 'QK_MOBILE_ORG_PREFERENCE';
export const QK_MOBILE_SLEEP_DIARY = 'QK_MOBILE_SLEEP_DIARY';
export const QK_MOBILE_USER = 'QK_MOBILE_USER';
export const QK_MOBILE_AGREEMENTS = 'QK_MOBILE_AGREEMENTS';
export const QK_MOBILE_SURVEY_SESSION = 'QK_MOBILE_SURVEY_SESSION';

// Notice
export const QK_NOTICE_LIST = 'QK_NOTICE_LIST';

// Manufacture
export const QK_MANUFACTURE_DEVICE_DETAIL = 'QK_MANUFACTURE_DEVICE_DETAIL';

// Scan Mini
export const QK_SCAN_MINI_PRESCRIPTION_LIST = 'QK_SCAN_MINI_PRESCRIPTION_LIST';
export const QK_SCAN_MINI_MY_PRESCRIPTION_LIST = 'QK_SCAN_MINI_MY_PRESCRIPTION_LIST';
export const QK_SCAN_MINI_ANALYSIS_FILES = 'QK_SCAN_MINI_ANALYSIS_FILES';
export const QK_SCAN_MINI_ANALYSIS_RESULT = 'QK_SCAN_MINI_ANALYSIS_RESULT';

// Delivery
export const QK_MY_DELIVERIES = 'QK_MY_DELIVERIES';
export const QK_DELIVERY_HISTORY = 'QK_DELIVERY_HISTORY';
export const QK_COURIER_COMPANIES = 'QK_COURIER_COMPANIES';
export const QK_SHIPPING_ADDRESS = 'QK_SHIPPING_ADDRESS';
export const QK_DELIVERY_REPLACEABLE = 'QK_DELIVERY_REPLACEABLE';
export const QK_DELIVERY_PENDING_SHIPMENTS = 'QK_DELIVERY_PENDING_SHIPMENTS';
export const QK_DELIVERY_BY_PRESCRIPTION = 'QK_DELIVERY_BY_PRESCRIPTION';
export const QK_DELIVERY_RETURN_HOLD = 'QK_DELIVERY_RETURN_HOLD';

// Stim Home
export const QK_STIM_HOME_PRESCRIPTION_LIST = 'QK_STIM_HOME_PRESCRIPTION_LIST';
export const QK_STIM_HOME_MY_PRESCRIPTION_LIST = 'QK_STIM_HOME_MY_PRESCRIPTION_LIST';
export const QK_STIM_HOME_PRESCRIPTION_BY_ID = 'QK_STIM_HOME_PRESCRIPTION_BY_ID';
export const QK_STIM_HOME_MY_CHECK_IN_HISTORY = 'QK_STIM_HOME_MY_CHECK_IN_HISTORY';
export const QK_STIM_HOME_DEFAULT_STIMULATION_SETTING = 'QK_STIM_HOME_DEFAULT_STIMULATION_SETTING';
export const QK_STIM_HOME_STIM_SESSION_LIST = 'QK_STIM_HOME_STIM_SESSION_LIST';
export const QK_STIM_HOME_ACTIVE_PRESCRIPTION_LIST = 'QK_STIM_HOME_ACTIVE_PRESCRIPTION_LIST';
export const QK_STIM_HOME_THERAPY_PROGRESS = 'QK_STIM_HOME_THERAPY_PROGRESS';
export const QK_STIM_HOME_CHECK_IN_HISTORY = 'QK_STIM_HOME_CHECK_IN_HISTORY';
export const QK_STIM_HOME_CHECK_IN_REMINDER = 'QK_STIM_HOME_CHECK_IN_REMINDER';

// Contract
export const QK_CONTRACT_ENTITLEMENTS = 'QK_CONTRACT_ENTITLEMENTS';

// Somzz (identity verification)
export const QK_SOMZZ_VERIFICATION = 'QK_SOMZZ_VERIFICATION';

// Dashboard (통합 대시보드 — org 단위 오늘 현황)
export const QK_DASHBOARD_ORG_STATUS = 'QK_DASHBOARD_ORG_STATUS';
// Dashboard 오늘의 동의 현황 — patient-api GET /agreements/org-status (오늘 동의완료)
export const QK_DASHBOARD_CONSENT_STATUS = 'QK_DASHBOARD_CONSENT_STATUS';
export const QK_DASHBOARD_AGREEMENT_DISPATCHES = 'QK_DASHBOARD_AGREEMENT_DISPATCHES';
export const QK_DASHBOARD_SLEEP_SUMMARY = 'QK_DASHBOARD_SLEEP_SUMMARY';
